import { render, staticRenderFns } from "./SkipLink.vue?vue&type=template&id=5858fa0c&scoped=true"
import script from "./SkipLink.vue?vue&type=script&lang=ts"
export * from "./SkipLink.vue?vue&type=script&lang=ts"
import style0 from "./SkipLink.vue?vue&type=style&index=0&id=5858fa0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5858fa0c",
  null
  
)

export default component.exports